import { BusinessTabName } from './BusinessTabs.types';
import { ROUTES } from '@/constants/routes';

export const BUSINESS_TABS = [
  {
    name: BusinessTabName.Packages,
    translationKey: 'pages.cabinet.packages',
    href: ROUTES.businessPackages,
  },
  {
    name: BusinessTabName.Balance,
    translationKey: 'pages.cabinet.balance',
    href: ROUTES.businessBalance,
  },
  {
    name: BusinessTabName.Invoices,
    translationKey: 'pages.cabinet.invoices',
    href: ROUTES.businessInvoices,
  },
];
